/* src/app/workshop/pages/vehicles/vehicles.component.scss */
/*# sourceMappingURL=vehicles.component.css.map */
